module.exports = __webpack_public_path__ + "static/footer_bg-4e67bf4d766909d9ba1da51877d7a632.svg";